import React from 'react'
import { SwitchTiersFlowMain } from './components/SwitchTiersFlowMain'
import { SwitchTiersFlowProvider } from './context/SwitchTiersFlowProvider'

export const SwitchTiersFlow = () => {
  return (
    <SwitchTiersFlowProvider>
      <SwitchTiersFlowMain />
    </SwitchTiersFlowProvider>
  )
}
